// extracted by mini-css-extract-plugin
export var form = "_de-0";